export class AltOfferingsEnvironment {
  public static getName = () => 'benzinga-alts';
  public static getEnvironment = (env: Record<string, string>) => ({
    // url: new URL(env.url ?? 'https://money.zingbot.bz/lavapress/api/'),
    url: new URL(env.url ?? 'https://www.benzinga.com/lavapress/api/'),
  });
}
